import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import About from './About';
import DuJourWrapper from './DuJourWrapper';
import CollectionWrapper from './CollectionWrapper'

function TabPanel(props) {
  const { children, value, index, heading, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography variant="h2" gutterBottom>
           {heading}
          </Typography>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const StyledRoot = styled('div')(({ theme }) => ({
  flexGrow: 1,
  backgroundColor: theme.palette.background.paper,
}));

const StyledFormControl = styled('div')(({ theme }) => ({
  margin: theme.spacing(2),
  minWidth: 200,
}));

export default function SimpleTabs() {
  const [selectedTab, setSelectedTab] = React.useState(0);
  const [updatedDate, setUpdatedDate] = React.useState(Date.now());
  const [requestedWatchId, setRequestedWatchId] = React.useState(null);
  const [makes, setMakes] = React.useState([]);
  const [selectedMake, setSelectedMake] = React.useState('All');

  React.useEffect(() => {
    fetch('https://psenakwatch.com/collection/phpsrc/getMakes.php')
      .then(res => res.json())
      .then(data => {
        if (data && data.watchList) {
          setMakes(data.watchList.map(item => item.make));
        }
      })
      .catch(err => {
        setMakes([]);
      });
  }, []);

  const handleMakeChange = (event) => {
    setSelectedMake(event.target.value);
  };

  const selectNewTab = (event, newValue) => {
    setSelectedTab(newValue);
    setRequestedWatchId(null);
  };

  const setDateWorn = async (watchId) => {
    const now = Math.round(Date.now() / 1000);
    const res = await fetch(`/collection/phpsrc/updateDateWorn.php`, { 
      method: 'POST',
      body: JSON.stringify({
        watchId : watchId,
        date: now,
        date_last_worn: now
      })
    })
    if (!res.ok) throw new Error(res.statusText);
    setUpdatedDate(Date.now());
  };

  return (
    <StyledRoot>
      <AppBar position="static" sx={{ backgroundColor: '#48bdf0' }}>
        <Tabs 
          value={selectedTab} 
          onChange={selectNewTab} 
          aria-label="simple tabs example"
          textColor="inherit"
          sx={{ '& .MuiTabs-indicator': { backgroundColor: '#ffffff' } }}
        >
          <Tab label="Du Jour" {...a11yProps(0)} sx={{ color: '#ffffff', '&.Mui-selected': { color: '#ffffff' } }} />
          <Tab label="Collection" {...a11yProps(1)} sx={{ color: '#ffffff', '&.Mui-selected': { color: '#ffffff' } }} />
          <Tab label="About" {...a11yProps(2)} sx={{ color: '#ffffff', '&.Mui-selected': { color: '#ffffff' } }} />
        </Tabs>
      </AppBar>
      <TabPanel value={selectedTab} index={0} heading={"You should really wear one of these"}>
        <DuJourWrapper 
          setDateWorn={setDateWorn} 
          updatedDate={updatedDate}
          setRequestedWatchId={setRequestedWatchId}
          requestedWatchId={requestedWatchId}
          selectedMake={selectedMake}
          makes={makes}
          handleMakeChange={handleMakeChange}
        />
      </TabPanel>
      <TabPanel value={selectedTab} index={1} heading={"You should buy another watch."}>
        <CollectionWrapper 
          setDateWorn={setDateWorn} 
          setRequestedWatchId={setRequestedWatchId}
          requestedWatchId={requestedWatchId}
          selectedMake={selectedMake}
          makes={makes}
          handleMakeChange={handleMakeChange}
        />
      </TabPanel>
      <TabPanel value={selectedTab} index={2} heading={"About page content"}>
        <About />
      </TabPanel>
      <TabPanel value={selectedTab} index={3} heading={"About page content"}>
        <About />
      </TabPanel>
    </StyledRoot>
  );
}
